import { render, staticRenderFns } from "./lazyblock_faq.vue?vue&type=template&id=42c96491&scoped=true"
import script from "./lazyblock_faq.vue?vue&type=script&lang=js"
export * from "./lazyblock_faq.vue?vue&type=script&lang=js"
import style0 from "./lazyblock_faq.vue?vue&type=style&index=0&id=42c96491&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c96491",
  null
  
)

export default component.exports